/**
 * ReceiptFormHeader Component
 *
 * Header with title and action buttons for the receipt form.
 */

import { Save, CheckCircle, Package } from 'lucide-react';
import { Button } from '@/components/ui';

interface ReceiptFormHeaderProps {
  isFromOrder: boolean;
  orderNumber: string;
  supplierName: string;
  isFormValid: boolean;
  isSaving: boolean;
  isValidating: boolean;
  onClose: () => void;
  onSaveDraft: () => void;
  onValidate: () => void;
}

export function ReceiptFormHeader({
  isFromOrder,
  orderNumber,
  supplierName,
  isFormValid,
  isSaving,
  isValidating,
  onClose,
  onSaveDraft,
  onValidate,
}: ReceiptFormHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary-100 rounded-lg">
          <Package className="w-5 h-5 text-primary-600" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-dark-500">Nouvelle reception</h2>
          <p className="text-sm text-neutral-500">
            {isFromOrder ? (
              <>
                Commande {orderNumber} - {supplierName}
              </>
            ) : (
              'Reception libre'
            )}
          </p>
        </div>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-3">
        <Button variant="ghost" onClick={onClose}>
          Annuler
        </Button>
        <Button
          variant="secondary"
          onClick={onSaveDraft}
          disabled={!isFormValid || isSaving}
        >
          {isSaving ? (
            <span className="flex items-center gap-2">
              <span className="animate-spin">...</span>
              Enregistrement...
            </span>
          ) : (
            <>
              <Save className="w-4 h-4" />
              Brouillon
            </>
          )}
        </Button>
        <Button
          variant="primary"
          onClick={onValidate}
          disabled={!isFormValid || isSaving || isValidating}
        >
          {isValidating ? (
            <span className="flex items-center gap-2">
              <span className="animate-spin">...</span>
              Validation...
            </span>
          ) : (
            <>
              <CheckCircle className="w-4 h-4" />
              Valider
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
